import IconCall from './IconCall';

export default IconCall;
